import { PlusCircleIcon } from '@assets/icons';
import { Button } from '@components/button';
import { useModal } from '@components/modal';
import { ServicesModal, ServicesModalHelpContent } from './ServicesModal';
import { useInpaintModal } from './inpaint';

type ServicesButtonProps = {
  disabled: boolean;
  volumeId: string;
  directory: string[];
};

export const ServicesButton = ({ disabled, volumeId, directory }: ServicesButtonProps) => {
  const { refetch: refetchInpaints } = useInpaintModal();
  const { showModal } = useModal({
    component: ServicesModal,
    componentProps: { volumeId, directory, refetchInpaints },
    modalProps: {
      help: <ServicesModalHelpContent />,
    },
  });

  return (
    <Button startIcon={PlusCircleIcon} variant="primary" disabled={disabled} onClick={showModal}>
      Create
    </Button>
  );
};
